import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';

import { AuthContext } from '../context/auth-context.tsx';
import { Loading } from '../loading.tsx';

export const InfraAdminRoute = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <Loading />;

  if (!user?.is_infra_admin) {
    // Redirect to `/`, matching OwnerOrAdminRoute and AdminRoute. Sending
    // non-infra-admins to settings/general was safe only while this guard was
    // nested inside OwnerOrAdminRoute; now that it is reachable by any member,
    // that target is itself role-gated and a plain member would bounce twice.
    return <Navigate to='/' replace />;
  }

  return <Outlet />;
};
